var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03_web_development_outline",
    "data-name": "#03_web_development_outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.44,222.43a10.34,10.34,0,0,0,.42-2.88c0-8.22-10-14.88-22.38-14.88s-22.38,6.66-22.38,14.88a10,10,0,0,0,.43,2.88Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44,223.43H254.53a1,1,0,0,1-1-.72,11.2,11.2,0,0,1-.47-3.16c0-8.76,10.49-15.88,23.38-15.88s23.38,7.12,23.38,15.88a10.86,10.86,0,0,1-.47,3.16A1,1,0,0,1,298.44,223.43Zm-43.14-2h42.36a9.32,9.32,0,0,0,.2-1.88c0-7.66-9.59-13.88-21.38-13.88s-21.38,6.22-21.38,13.88A9.32,9.32,0,0,0,255.3,221.43Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,214.55a1,1,0,0,1-1-1v-8.88a1,1,0,1,1,2,0v8.88A1,1,0,0,1,276.48,214.55Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 222.43,
    width: 236.2,
    height: 12.48,
    rx: 5.77,
    fill: "#725858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.33,235.91H87.67a6.78,6.78,0,0,1-6.77-6.77v-.94a6.78,6.78,0,0,1,6.77-6.77H312.33a6.78,6.78,0,0,1,6.77,6.77v.94A6.78,6.78,0,0,1,312.33,235.91ZM87.67,223.43a4.78,4.78,0,0,0-4.77,4.77v.94a4.78,4.78,0,0,0,4.77,4.77H312.33a4.78,4.78,0,0,0,4.77-4.77v-.94a4.78,4.78,0,0,0-4.77-4.77Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.71,
    y: 73.11,
    width: 162.58,
    height: 122.89,
    rx: 9.99,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,197H128.7a11,11,0,0,1-11-11V83.1a11,11,0,0,1,11-11H271.3a11,11,0,0,1,11,11V186A11,11,0,0,1,271.3,197ZM128.7,74.11a9,9,0,0,0-9,9V186a9,9,0,0,0,9,9H271.3a9,9,0,0,0,9-9V83.1a9,9,0,0,0-9-9Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.82 222.43 171.18 222.43 177.2 196 222.8 196 228.82 222.43",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,223.43H171.18a1,1,0,0,1-.78-.38,1,1,0,0,1-.19-.84l6-26.43a1,1,0,0,1,1-.78h45.6a1,1,0,0,1,1,.78l6,26.43a1,1,0,0,1-.19.84A1,1,0,0,1,228.82,223.43Zm-56.38-2h55.12L222,197H178Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.79,
    y: 83.35,
    width: 140.41,
    height: 91.21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.21,175.56H129.79a1,1,0,0,1-1-1V83.35a1,1,0,0,1,1-1H270.21a1,1,0,0,1,1,1v91.21A1,1,0,0,1,270.21,175.56Zm-139.42-2H269.21V84.35H130.79Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.79,
    y: 83.35,
    width: 41.39,
    height: 91.21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,175.56H129.79a1,1,0,0,1-1-1V83.35a1,1,0,0,1,1-1h41.39a1,1,0,0,1,1,1v91.21A1,1,0,0,1,171.18,175.56Zm-40.39-2h39.39V84.35H130.79Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.18,
    y: 83.35,
    width: 99.02,
    height: 91.21,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.21,175.56h-99a1,1,0,0,1-1-1V83.35a1,1,0,0,1,1-1h99a1,1,0,0,1,1,1v91.21A1,1,0,0,1,270.21,175.56Zm-98-2h97V84.35h-97Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.72,95.89h-16.8a1,1,0,0,1,0-2h16.8a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.6,105.73H147.44a1,1,0,0,1,0-2H161.6a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.52,115.57H151.76a1,1,0,0,1,0-2h11.76a1,1,0,1,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.68,125.41H144.8a1,1,0,0,1,0-2h14.88a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,135.25H141.92a1,1,0,1,1,0-2h13.76a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.72,145.09H146.56a1,1,0,0,1,0-2h12.16a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.52,154.93h-12.6a1,1,0,0,1,0-2h12.6a1,1,0,1,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.72,164.77H146.56a1,1,0,0,1,0-2h12.16a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,95.89h-16.8a1,1,0,0,1,0-2H201a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.16,105.73H189.68a1,1,0,0,1,0-2h34.48a1,1,0,0,1,0,2Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,115.57H189.68a1,1,0,0,1,0-2H215.6a1,1,0,0,1,0,2Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.92,125.41H187a1,1,0,0,1,0-2h14.88a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.84,135.25H191a1,1,0,1,1,0-2h16.8a1,1,0,1,1,0,2Z",
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,145.09H190.46a1,1,0,0,1,0-2H216.4a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,154.93h-12.6a1,1,0,0,1,0-2h12.6a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,164.77H188.8a1,1,0,0,1,0-2h27.6a1,1,0,0,1,0,2Z",
    fill: "#70cc40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,164.77H224.72a1,1,0,0,1,0-2h18.12a1,1,0,0,1,0,2Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,115.57h-12.8a1,1,0,0,1,0-2H237a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21,105.73H230.56a1,1,0,0,1,0-2h24.65a1,1,0,1,1,0,2Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.12,115.57h-7.2a1,1,0,0,1,0-2h7.2a1,1,0,0,1,0,2Z",
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,135.25h-7.2a1,1,0,0,1,0-2H220a1,1,0,0,1,0,2Z",
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21,135.25H225.92a1,1,0,1,1,0-2h29.29a1,1,0,1,1,0,2Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.56,145.09h-6.4a1,1,0,0,1,0-2h6.4a1,1,0,0,1,0,2Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21,164.77h-4.09a1,1,0,0,1,0-2h4.09a1,1,0,0,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.35,
    y: 65.09,
    width: 69.99,
    height: 55.32,
    rx: 4.36,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,121.41H247.71a5.37,5.37,0,0,1-5.36-5.36V69.45a5.37,5.37,0,0,1,5.36-5.36H309a5.37,5.37,0,0,1,5.36,5.36v46.6A5.37,5.37,0,0,1,309,121.41ZM247.71,66.09a3.37,3.37,0,0,0-3.36,3.36v46.6a3.37,3.37,0,0,0,3.36,3.36H309a3.37,3.37,0,0,0,3.36-3.36V69.45A3.37,3.37,0,0,0,309,66.09Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,78.73h-70a1,1,0,0,1,0-2h70a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.05,
    cy: 71.24,
    r: 2.01,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.37,
    cy: 71.24,
    r: 2.01,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.68,
    cy: 71.24,
    r: 2.01,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.73,107.19a.94.94,0,0,1-.63-.23l-9.42-7.8a1,1,0,0,1,0-1.54l9.42-7.81a1,1,0,0,1,1.27,1.54l-8.48,7,8.48,7a1,1,0,0,1,.13,1.41A1,1,0,0,1,269.73,107.19Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,107.19a1,1,0,0,1-.77-.36,1,1,0,0,1,.13-1.41l8.48-7-8.48-7a1,1,0,0,1,1.28-1.54L297,97.62a1,1,0,0,1,0,1.54L287.6,107A1,1,0,0,1,287,107.19Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,111.84a1.14,1.14,0,0,1-.4-.08,1,1,0,0,1-.51-1.32l11-24.91a1,1,0,0,1,1.32-.51,1,1,0,0,1,.51,1.32l-11,24.91A1,1,0,0,1,273.29,111.84Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.76,
    y: 180.22,
    width: 54.22,
    height: 28.99,
    rx: 3.83,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.15,210.22H107.59a4.84,4.84,0,0,1-4.83-4.83V184.05a4.84,4.84,0,0,1,4.83-4.83h46.56a4.83,4.83,0,0,1,4.83,4.83v21.34A4.83,4.83,0,0,1,154.15,210.22Zm-46.56-29a2.83,2.83,0,0,0-2.83,2.83v21.34a2.83,2.83,0,0,0,2.83,2.83h46.56a2.83,2.83,0,0,0,2.83-2.83V184.05a2.83,2.83,0,0,0-2.83-2.83Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.85,190.31h1.51v3.38h4v-3.38h1.51v8.5h-1.51v-3.75h-4v3.75h-1.51Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.48,191.68h-2.61v-1.37h6.72v1.37H127v7.13h-1.51Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.66,190.31H133l2.27,5.95,2.29-5.95h2.28v8.5h-1.44v-7.06h0l-2.58,7.06H134.7l-2.57-7.06h0v7.06h-1.44Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,190.31h1.51v7.13h3.61v1.37h-5.12Z",
    fill: "#1e3a8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.bceccecdef8e71bd5a8d73effe14fdba.svg";
export { ForwardRef as ReactComponent };